<template>
  <div :class="$style.wrapper">
    <div :class="$style.container" @click="showDetail = true">
      <div :class="$style.title">
        <TitleThumb :bgColor="thumb.bgColor" :bgImg="thumb.bgImg">
          {{ thumb.title }}
        </TitleThumb>
        <ModeDisplay :class="$style.mode" :level="history.level" :limit="history.time_limited" />
      </div>

      <div :class="$style.info">
        <div :class="$style.score">
          <Coin :n="history.score" :size="24" />
        </div>

        <div :class="$style.correct">
          <SvgIcon
            :svg="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/check.svg')"
            :size="36"
            :class="[$style.svg, $style.correctSvg]"
          />
          <div>{{ correctCount }}</div>
        </div>

        <div :class="$style.wrong">
          <SvgIcon
            :svg="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/close.svg')"
            :size="36"
            :class="[$style.svg, $style.wrongSvg]"
          />
          <div>{{ wrongCount }}</div>
        </div>
      </div>

    </div>
    <Detail v-if="showDetail" :history="history" @close="showDetail = false" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TitleThumb from '@/components/TitleThumb'
import ModeDisplay from '@/components/ModeDisplay'
import Coin from '@/components/Coin'
import SvgIcon from '@/components/SvgIcon'
import Detail from './Detail'

export default {
  components: {
    TitleThumb,
    ModeDisplay,
    Coin,
    SvgIcon,
    Detail,
  },
  props: {
    history: {
      required: true,
      type: Object,
    },
  },
  data () {
    return {
      showDetail: false,
    }
  },
  computed: {
    thumb () {
      const type = this.history.type
      return this.thumbs.find(t => t.key == type)
    },
    correctCount () {
      return this.history.questions.filter(q => q.is_correct).length
    },
    wrongCount () {
      return this.history.questions.filter(q => !q.is_correct).length
    },
    ...mapState([
      'thumbs',
    ]),
  },
}
</script>

<style lang="scss" module>
.container {
  background-color: rgba(255, 255, 255, 0.3);
  @apply overflow-hidden;
  @apply rounded-lg;
  @apply shadow;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: auto 1fr;
  grid-template-areas: "title info";

  &:hover {
    @apply cursor-pointer;
    @apply shadow-lg;
    transition: .3s all;
  }
}

.title {
  @apply relative;
  grid-area: title;
}

.mode {
  @apply absolute;
  @apply top-0;
  @apply inset-x-0;
}

.info {
  grid-area: info;
  display: grid;
  @apply py-1;
  @apply px-8;
  grid-template-rows: 50px 50px auto;
  grid-template-columns: 80px 80px 80px auto;
  grid-template-areas:
    ". . . ."
    "score correct wrong ."
    ". . . .";
}

.score,
.correct,
.wrong {
  @apply flex;
  @apply items-center;
  font-size: 24px;
  @apply leading-none;
  @apply mx-2;
}

.score {
  grid-area: score;
}

.correct {
  grid-area: correct;
}

.wrong {
  grid-area: wrong;
}

.correctSvg {
  color: #00ff00;
}

.wrongSvg {
  color: #ff0000;
}
</style>
